import React from "react"
import dayjs, { Dayjs } from "dayjs"
import MenuItem from "@mui/material/MenuItem"
import Stack from "@mui/material/Stack"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import { DatePicker } from "@mui/x-date-pickers"
import DateRangeIcon from "@mui/icons-material/DateRange"
import {
  useGetScheduleSelectQuery,
  useGetDepartmentQuery,
  useGetLineQuery,
  useGetTimeSlotsSelectQuery,
} from "../../../../api/InterviewsApi"
import { useSelector } from "react-redux/es/hooks/useSelector"
import { RootState } from "../../../../../../app/store"
import { useDispatch } from "react-redux/es/hooks/useDispatch"
import { setInterviewDateState } from "../../dialogs/model/Interviews"

const InterviewInformationTab = ({
  register,
  selects,
  watch,
  resetField,
  setValue,
  clearErrors,
  formState,
}: any) => {
  // const department = useGetDepartmentQuery(
  //   watch("interviewInformation.project", {
  //     skip,
  //   }),
  // )

  const { errors } = formState

  const department = useGetDepartmentQuery(
    watch("interviewInformation.project"),
    {
      skip: !watch("interviewInformation.project"),
    },
  )

  const line = useGetLineQuery(watch("interviewInformation.department"), {
    skip: !watch("interviewInformation.department"),
  })

  const scheduleSelect = useGetScheduleSelectQuery(
    `graphType=${watch("interviewInformation.graphType")}&project=${watch(
      "interviewInformation.project",
    )}&department=${watch("interviewInformation.department")}&line=${watch(
      "interviewInformation.line",
    )}&id=${watch("id") === undefined ? "" : watch("id")}`,
    {
      skip: !watch("interviewInformation.graphType"),
    },
  )
  const timeSlotsSelect = useGetTimeSlotsSelectQuery(
    `interviewer=${watch("interviewInformation.interviewer")}&id=${
      watch("id") === undefined ? "" : watch("id")
    } `,
    {
      skip: !watch("interviewInformation.interviewer"),
    },
  )

  const interviewRow = useSelector((state: RootState) => state.interviewRow)
  const interviewMode = useSelector((state: RootState) => state.interviewMode)
  const interviewDate = useSelector((state: RootState) => state.interviewDate)
  const dispatch = useDispatch()

  // console.log(interviewRow.timeSlots.id, "row")

  return (
    <Stack direction={"row"} spacing={"40px"}>
      <Stack spacing={"20px"} sx={{ width: "480px" }}>
        <Stack direction={"column"} spacing={"5px"}>
          <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
            Собеседующий
          </Typography>
          <TextField
            size="small"
            label="Собеседующий"
            inputProps={register("interviewInformation.interviewer")}
            fullWidth
            value={watch("interviewInformation.interviewer")}
            select
          >
            {selects?.interviewSchedule?.interviewer.map((option: any) => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
        <Stack direction={"column"} spacing={"5px"}>
          <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
            Дата и время собеседования
          </Typography>
          <TextField
            disabled={!timeSlotsSelect.data}
            size="small"
            label={"Выберите существующий слот"}
            inputProps={register("interviewInformation.interviewDateTime")}
            fullWidth
            value={watch("interviewInformation.interviewDateTime")}
            select
          >
            {timeSlotsSelect.data?.map((option: any) => (
              <MenuItem
                disabled={!option.timeSlot.status}
                key={option.id}
                value={option.id}
              >
                {`Слот на ${dayjs(option.timeSlot.date).format(
                  "DD.MM.YY",
                )} в ${dayjs(option.timeSlot.startDate).format(
                  "HH:mm",
                )}-${dayjs(option.timeSlot.endDate).format(
                  "HH:mm",
                )} ${option.timeSlot.type.toLowerCase()}`}
              </MenuItem>
            ))}
          </TextField>
        </Stack>

        {/* <Stack direction={"column"} spacing={"5px"}>
          <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
            Планируемая дата выхода
          </Typography>
          <Stack
            alignItems={"center"}
            justifyContent={"center"}
            direction={"row"}
            spacing={"5px"}
          >
            <DatePicker
              slots={{
                openPickerIcon: DateRangeIcon,
              }}
              sx={{
                ".MuiIconButton-root": { color: "rgba(139, 139, 139, 1)" },
              }}
              value={
                interviewMode.mode === "edit"
                  ? interviewRow.workDays.startDate
                    ? dayjs(watch("interviewInformation.workDays.startDate"))
                    : null
                  : interviewDate.workDaysStartDate
              }
              localeText={{
                toolbarTitle: "ЧЧ.ММ.ГГГГ",
                fieldDayPlaceholder: () => "ДД",
                fieldMonthPlaceholder: () => "ММ",
                fieldYearPlaceholder: () => "ГГГГ",
              }}
              onChange={(e: Dayjs | null) => {
                dayjs(e).isValid() &&
                  clearErrors("interviewInformation.workDays.startDate")
                setValue(
                  "interviewInformation.workDays.startDate",
                  dayjs(e).format("YYYY-MM-DDTHH:mm:ssZ"),
                )
                dispatch(
                  setInterviewDateState({
                    ...interviewDate,
                    workDaysStartDate: dayjs(e),
                  }),
                )
              }}
              format="DD.MM.YYYY"
              slotProps={{
                textField: {
                  inputProps: register(
                    "interviewInformation.workDays.startDate",
                  ),
                  size: "small",
                  variant: "outlined",
                  placeholder: "ДД.ММ.ГГГГ",
                },
              }}
            />
            <div
              style={{
                width: "10px",
                height: "1px",
                background: "#CACACA",
                borderRadius: 4,
              }}
            />
            <DatePicker
              slots={{
                openPickerIcon: DateRangeIcon,
              }}
              sx={{
                ".MuiIconButton-root": { color: "rgba(139, 139, 139, 1)" },
              }}
              value={
                interviewMode.mode === "edit"
                  ? interviewRow.workDays.endDate
                    ? dayjs(watch("interviewInformation.workDays.endDate"))
                    : null
                  : interviewDate.workDaysEndDate
              }
              localeText={{
                toolbarTitle: "ЧЧ.ММ.ГГГГ",
                fieldDayPlaceholder: () => "ДД",
                fieldMonthPlaceholder: () => "ММ",
                fieldYearPlaceholder: () => "ГГГГ",
              }}
              onChange={(e: Dayjs | null) => {
                dayjs(e).isValid() &&
                  clearErrors("interviewInformation.workDays.endDate")
                setValue(
                  "interviewInformation.workDays.endDate",
                  dayjs(e).format("YYYY-MM-DDTHH:mm:ssZ"),
                )
                dispatch(
                  setInterviewDateState({
                    ...interviewDate,
                    workDaysEndDate: dayjs(e),
                  }),
                )
              }}
              format="DD.MM.YYYY"
              slotProps={{
                textField: {
                  inputProps: register("interviewInformation.workDays.endDate"),
                  size: "small",
                  variant: "outlined",
                  placeholder: "ДД.ММ.ГГГГ",
                },
              }}
            />
          </Stack>
        </Stack> */}
        <Stack direction={"column"} spacing={"5px"}>
          <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
            Рекрутёр масснайма *
          </Typography>
          <TextField
            label="Выбрать результат"
            size="small"
            placeholder="Выбрать результат"
            inputProps={register("resultate.massRecruiter", {
              required: "Это поле обязательно для заполнения",
            })}
            error={!!errors?.resultate?.massRecruiter}
            helperText={errors?.resultate?.massRecruiter?.message || ""}
            fullWidth
            value={watch("resultate.massRecruiter")}
            select
          >
            {selects?.interviewSchedule?.massRecruiter.map((option: any) => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
      </Stack>
      <Stack spacing={"20px"} sx={{ width: "480px" }}>
        <Stack direction={"column"} spacing={"5px"}>
          <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
            Проект
          </Typography>
          <TextField
            size="small"
            label="Проект"
            inputProps={register("interviewInformation.project")}
            fullWidth
            value={watch("interviewInformation.project") || null}
            select
            onChange={() => {
              setValue("interviewInformation.department", null)
              setValue("interviewInformation.line", null)
              setValue("interviewInformation.graphType", null)
              setValue("interviewInformation.schedule", null)
            }}
          >
            {selects?.interviewSchedule?.project.map((option: any) => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
        <Stack direction={"column"} spacing={"5px"}>
          <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
            Направление
          </Typography>
          <TextField
            disabled={!department?.data}
            size="small"
            label="Направление"
            inputProps={register("interviewInformation.department")}
            fullWidth
            value={watch("interviewInformation.department") || null}
            select
            onChange={() => {
              setValue("interviewInformation.line", null)
              setValue("interviewInformation.graphType", null)
              setValue("interviewInformation.schedule", null)
            }}
          >
            {department.data?.map((option: any) => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
        <Stack direction={"column"} spacing={"5px"}>
          <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
            Линия
          </Typography>
          <TextField
            disabled={!line.data}
            size="small"
            label="Линия"
            inputProps={register("interviewInformation.line")}
            fullWidth
            value={watch("interviewInformation.line") || null}
            select
            onChange={() => {
              setValue("interviewInformation.graphType", null)
              setValue("interviewInformation.schedule", null)
            }}
          >
            {line.data?.data.map((option: any) => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
        <Stack direction={"column"} spacing={"5px"}>
          <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
            Тип графика
          </Typography>
          <TextField
            disabled={!watch("interviewInformation.line")}
            size="small"
            label="Тип графика"
            inputProps={register("interviewInformation.graphType")}
            fullWidth
            value={watch("interviewInformation.graphType") || null}
            select
            onChange={() => {
              setValue("interviewInformation.schedule", null)
            }}
          >
            {selects?.interviewSchedule?.graphType?.map((option: any) => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
        <Stack direction={"column"} spacing={"5px"}>
          <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
            График
          </Typography>

          <TextField
            disabled={!scheduleSelect.data}
            size="small"
            label="График"
            inputProps={register("interviewInformation.schedule")}
            fullWidth
            value={watch("interviewInformation.schedule") || null}
            select
          >
            {scheduleSelect.data?.map((option: any) => (
              <MenuItem key={option.id} value={option.id}>
                <Stack direction={"row"} alignItems="center">
                  {option.id && (
                    <Typography
                      sx={{ fontSize: 12, mr: "6px" }}
                      color="text.secondary"
                    >
                      id:{option.id}
                    </Typography>
                  )}
                  {`${option.schedule.pattern}  ${dayjs
                    .utc(option.schedule.startDate)
                    .format("HH:mm")} - ${dayjs
                    .utc(option.schedule.endDate)
                    .format("HH:mm")} ${"   "} ${dayjs(
                    option.workDays?.startDate,
                  )
                    .utc()
                    .format("DD.MM")} -
                  ${dayjs(option.workDays?.endDate).utc().format("DD.MM")} `}
                </Stack>
              </MenuItem>
            ))}
          </TextField>
        </Stack>
        {/* <Stack direction={"column"} spacing={"5px"}>
          <Typography sx={{ fontSize: 14, fontWeight: "bold" }}>
            Тип собеседования
          </Typography>
          <TextField
            size="small"
            label="Тип собеседования"
            inputProps={register("interviewInformation.interviewType.id")}
            fullWidth
            value={watch("interviewInformation.interviewType.id")}
            select
          >
            {selects?.interviewType.map((option: any) => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>
        </Stack> */}
      </Stack>
    </Stack>
  )
}

export default InterviewInformationTab
